export const currencies = [
  {
    "currency": "AED",
    "descriptionCurrency": "dírham de los Emiratos Árabes Unidos",
    "symbol": "د.إ"
  },
  {
    "currency": "AFN",
    "descriptionCurrency": "afgani afgano",
    "symbol": "؋"
  },
  {
    "currency": "ALL",
    "descriptionCurrency": "lek albanés",
    "symbol": "L"
  },
  {
    "currency": "AMD",
    "descriptionCurrency": "dram armenio",
    "symbol": "֏"
  },
  {
    "currency": "ANG",
    "descriptionCurrency": "florín antillano neerlandés",
    "symbol": "ƒ"
  },
  {
    "currency": "AOA",
    "descriptionCurrency": "kwanza angoleño",
    "symbol": "Kz"
  },
  {
    "currency": "ARS",
    "descriptionCurrency": "peso argentino",
    "symbol": "$"
  },
  {
    "currency": "AUD",
    "descriptionCurrency": "dólar australiano",
    "symbol": "$"
  },
  {
    "currency": "ATS",
    "descriptionCurrency": "chelín austriaco",
    "symbol": "öS"
  },
  {
    "currency": "GRD",
    "descriptionCurrency": "dragma griego",
    "symbol": "₯"
  },
  {
    "currency": "SKK",
    "descriptionCurrency": "corona eslovaca",
    "symbol": "Sk"
  },
  {
    "currency": "VES",
    "descriptionCurrency": "bolívar venezolano",
    "symbol": "Bs."
  },
  {
    "currency": "PTE",
    "descriptionCurrency": "escudo portugués",
    "symbol": "Esc"
  },
  {
    "currency": "NLG",
    "descriptionCurrency": "florín holandés",
    "symbol": "ƒ"
  },
  {
    "currency": "BEF",
    "descriptionCurrency": "franco belga",
    "symbol": "₣"
  },
  {
    "currency": "FRF",
    "descriptionCurrency": "franco francés",
    "symbol": "₣"
  },
  {
    "currency": "IEP",
    "descriptionCurrency": "libra irlandesa",
    "symbol": "£"
  },
  {
    "currency": "ITL",
    "descriptionCurrency": "lira italiana",
    "symbol": "₤"
  },
  {
    "currency": "DEM",
    "descriptionCurrency": "marco alemán",
    "symbol": "DM"
  },
  {
    "currency": "FIM",
    "descriptionCurrency": "marco finlandés",
    "symbol": "mk"
  },
  {
    "currency": "ESP",
    "descriptionCurrency": "peseta española",
    "symbol": "₧"
  },
  {
    "currency": "XAU",
    "descriptionCurrency": "peso oro",
    "symbol": "XAU"
  },
  {
    "currency": "XPT",
    "descriptionCurrency": "peso netear",
    "symbol": "XPT"
  },
  {
    "currency": "SUC",
    "descriptionCurrency": "sucre ecuatoriano",
    "symbol": "S/."
  },
  {
    "currency": "AWG",
    "descriptionCurrency": "florín arubeño",
    "symbol": "ƒ"
  },
  {
    "currency": "AZN",
    "descriptionCurrency": "manat azerí",
    "symbol": "₼"
  },
  {
    "currency": "BAM",
    "descriptionCurrency": "marco convertible de Bosnia y Herzegovina",
    "symbol": "KM"
  },
  {
    "currency": "BBD",
    "descriptionCurrency": "dólar barbadense",
    "symbol": "$"
  },
  {
    "currency": "BDT",
    "descriptionCurrency": "taka bangladesí",
    "symbol": "৳"
  },
  {
    "currency": "BGN",
    "descriptionCurrency": "lev búlgaro",
    "symbol": "лв"
  },
  {
    "currency": "BHD",
    "descriptionCurrency": "dinar bahreiní",
    "symbol": ".د.ب"
  },
  {
    "currency": "BIF",
    "descriptionCurrency": "franco burundés",
    "symbol": "FBu"
  },
  {
    "currency": "BMD",
    "descriptionCurrency": "dólar bermudeño",
    "symbol": "$"
  },
  {
    "currency": "BND",
    "descriptionCurrency": "dólar de Brunéi",
    "symbol": "$"
  },
  {
    "currency": "BOB",
    "descriptionCurrency": "boliviano",
    "symbol": "Bs."
  },
  {
    "currency": "BRL",
    "descriptionCurrency": "real brasileño",
    "symbol": "R$"
  },
  {
    "currency": "BSD",
    "descriptionCurrency": "dólar bahameño",
    "symbol": "$"
  },
  {
    "currency": "BTN",
    "descriptionCurrency": "ngultrum butanés",
    "symbol": "Nu."
  },
  {
    "currency": "BWP",
    "descriptionCurrency": "pula botsuano",
    "symbol": "P"
  },
  {
    "currency": "BYN",
    "descriptionCurrency": "rublo bielorruso",
    "symbol": "Br"
  },
  {
    "currency": "BZD",
    "descriptionCurrency": "dólar beliceño",
    "symbol": "BZ$"
  },
  {
    "currency": "CAD",
    "descriptionCurrency": "dólar canadiense",
    "symbol": "$"
  },
  {
    "currency": "CDF",
    "descriptionCurrency": "franco congoleño",
    "symbol": "FC"
  },
  {
    "currency": "CHF",
    "descriptionCurrency": "franco suizo",
    "symbol": "Fr."
  },
  {
    "currency": "CLP",
    "descriptionCurrency": "peso chileno",
    "symbol": "$"
  },
  {
    "currency": "CNY",
    "descriptionCurrency": "yuan chino",
    "symbol": "¥"
  },
  {
    "currency": "COP",
    "descriptionCurrency": "peso colombiano",
    "symbol": "$"
  },
  {
    "currency": "CRC",
    "descriptionCurrency": "colón costarricense",
    "symbol": "₡"
  },
  {
    "currency": "CUC",
    "descriptionCurrency": "peso convertible cubano",
    "symbol": "$"
  },
  {
    "currency": "CUP",
    "descriptionCurrency": "peso cubano",
    "symbol": "$"
  },
  {
    "currency": "CVE",
    "descriptionCurrency": "escudo caboverdiano",
    "symbol": "$"
  },
  {
    "currency": "CZK",
    "descriptionCurrency": "corona checa",
    "symbol": "Kč"
  },
  {
    "currency": "DJF",
    "descriptionCurrency": "franco yibutiano",
    "symbol": "Fdj"
  },
  {
    "currency": "DKK",
    "descriptionCurrency": "corona danesa",
    "symbol": "kr"
  },
  {
    "currency": "DOP",
    "descriptionCurrency": "peso dominicano",
    "symbol": "RD$"
  },
  {
    "currency": "DZD",
    "descriptionCurrency": "dinar argelino",
    "symbol": "د.ج"
  },
  {
    "currency": "EGP",
    "descriptionCurrency": "libra egipcia",
    "symbol": "£"
  },
  {
    "currency": "ERN",
    "descriptionCurrency": "nakfa eritreo",
    "symbol": "Nfk"
  },
  {
    "currency": "ETB",
    "descriptionCurrency": "birr etíope",
    "symbol": "Br"
  },
  {
    "currency": "EUR",
    "descriptionCurrency": "euro",
    "symbol": "€"
  },
  {
    "currency": "FJD",
    "descriptionCurrency": "dólar fiyiano",
    "symbol": "$"
  },
  {
    "currency": "FKP",
    "descriptionCurrency": "libra malvinense",
    "symbol": "£"
  },
  {
    "currency": "GBP",
    "descriptionCurrency": "libra esterlina",
    "symbol": "£"
  },
  {
    "currency": "GEL",
    "descriptionCurrency": "lari georgiano",
    "symbol": "₾"
  },
  {
    "currency": "GGP",
    "descriptionCurrency": "libra de Guernsey",
    "symbol": "£"
  },
  {
    "currency": "GHS",
    "descriptionCurrency": "cedi ghanés",
    "symbol": "₵"
  },
  {
    "currency": "GIP",
    "descriptionCurrency": "libra gibraltareña",
    "symbol": "£"
  },
  {
    "currency": "GMD",
    "descriptionCurrency": "dalasi gambiano",
    "symbol": "D"
  },
  {
    "currency": "GNF",
    "descriptionCurrency": "franco guineano",
    "symbol": "FG"
  },
  {
    "currency": "GTQ",
    "descriptionCurrency": "quetzal guatemalteco",
    "symbol": "Q"
  },
  {
    "currency": "GYD",
    "descriptionCurrency": "dólar guyanés",
    "symbol": "$"
  },
  {
    "currency": "HKD",
    "descriptionCurrency": "dólar de Hong Kong",
    "symbol": "$"
  },
  {
    "currency": "HNL",
    "descriptionCurrency": "lempira hondureño",
    "symbol": "L"
  },
  {
    "currency": "HRK",
    "descriptionCurrency": "kuna croata",
    "symbol": "kn"
  },
  {
    "currency": "HTG",
    "descriptionCurrency": "gourde haitiano",
    "symbol": "G"
  },
  {
    "currency": "HUF",
    "descriptionCurrency": "forinto húngaro",
    "symbol": "Ft"
  },
  {
    "currency": "IDR",
    "descriptionCurrency": "rupia indonesia",
    "symbol": "Rp"
  },
  {
    "currency": "ILS",
    "descriptionCurrency": "nuevo shekel israelí",
    "symbol": "₪"
  },
  {
    "currency": "IMP",
    "descriptionCurrency": "libra manesa",
    "symbol": "£"
  },
  {
    "currency": "INR",
    "descriptionCurrency": "rupia india",
    "symbol": "₹"
  },
  {
    "currency": "IQD",
    "descriptionCurrency": "dinar iraquí",
    "symbol": "ع.د"
  },
  {
    "currency": "IRR",
    "descriptionCurrency": "rial iraní",
    "symbol": "﷼"
  },
  {
    "currency": "ISK",
    "descriptionCurrency": "corona islandesa",
    "symbol": "kr"
  },
  {
    "currency": "JEP",
    "descriptionCurrency": "libra jerosolimitana",
    "symbol": "£"
  },
  {
    "currency": "JMD",
    "descriptionCurrency": "dólar jamaiquino",
    "symbol": "J$"
  },
  {
    "currency": "JOD",
    "descriptionCurrency": "dinar jordano",
    "symbol": "د.ا"
  },
  {
    "currency": "JPY",
    "descriptionCurrency": "yen japonés",
    "symbol": "¥"
  },
  {
    "currency": "KES",
    "descriptionCurrency": "chelín keniano",
    "symbol": "Ksh"
  },
  {
    "currency": "KGS",
    "descriptionCurrency": "som kirguís",
    "symbol": "с"
  },
  {
    "currency": "KHR",
    "descriptionCurrency": "riel camboyano",
    "symbol": "៛"
  },
  {
    "currency": "KMF",
    "descriptionCurrency": "franco comorense",
    "symbol": "CF"
  },
  {
    "currency": "KPW",
    "descriptionCurrency": "won norcoreano",
    "symbol": "₩"
  },
  {
    "currency": "KRW",
    "descriptionCurrency": "won surcoreano",
    "symbol": "₩"
  },
  {
    "currency": "KWD",
    "descriptionCurrency": "dinar kuwaití",
    "symbol": "د.ك"
  },
  {
    "currency": "KYD",
    "descriptionCurrency": "dólar de las Islas Caimán",
    "symbol": "$"
  },
  {
    "currency": "KZT",
    "descriptionCurrency": "tenge kazajo",
    "symbol": "₸"
  },
  {
    "currency": "LAK",
    "descriptionCurrency": "kip laosiano",
    "symbol": "₭"
  },
  {
    "currency": "LBP",
    "descriptionCurrency": "libra libanesa",
    "symbol": "ل.ل"
  },
  {
    "currency": "LKR",
    "descriptionCurrency": "rupia de Sri Lanka",
    "symbol": "රු"
  },
  {
    "currency": "LRD",
    "descriptionCurrency": "dólar liberiano",
    "symbol": "$"
  },
  {
    "currency": "LSL",
    "descriptionCurrency": "loti lesothense",
    "symbol": "L"
  },
  {
    "currency": "LYD",
    "descriptionCurrency": "dinar libio",
    "symbol": "ل.د"
  },
  {
    "currency": "MAD",
    "descriptionCurrency": "dírham marroquí",
    "symbol": "د.م."
  },
  {
    "currency": "MDL",
    "descriptionCurrency": "leu moldavo",
    "symbol": "L"
  },
  {
    "currency": "MGA",
    "descriptionCurrency": "ariary malgache",
    "symbol": "Ar"
  },
  {
    "currency": "MKD",
    "descriptionCurrency": "dinar macedonio",
    "symbol": "ден"
  },
  {
    "currency": "MMK",
    "descriptionCurrency": "kyat birmano",
    "symbol": "Ks"
  },
  {
    "currency": "MNT",
    "descriptionCurrency": "tugrik mongol",
    "symbol": "₮"
  },
  {
    "currency": "MOP",
    "descriptionCurrency": "pataca de Macao",
    "symbol": "P"
  },
  {
    "currency": "MRO",
    "descriptionCurrency": "ouguiya mauritano",
    "symbol": "UM"
  },
  {
    "currency": "MRU",
    "descriptionCurrency": "ouguiya mauritano",
    "symbol": "UM"
  },
  {
    "currency": "MUR",
    "descriptionCurrency": "rupia mauriciana",
    "symbol": "₨"
  },
  {
    "currency": "MVR",
    "descriptionCurrency": "rufiyaa maldiva",
    "symbol": "ރ."
  },
  {
    "currency": "MWK",
    "descriptionCurrency": "kwacha malauí",
    "symbol": "MK"
  },
  {
    "currency": "MXN",
    "descriptionCurrency": "peso mexicano",
    "symbol": "$"
  },
  {
    "currency": "MXP",
    "descriptionCurrency": "peso mexicano",
    "symbol": "$"
  },
  {
    "currency": "MYR",
    "descriptionCurrency": "ringgit malayo",
    "symbol": "RM"
  },
  {
    "currency": "MZN",
    "descriptionCurrency": "metical mozambiqueño",
    "symbol": "MT"
  },
  {
    "currency": "NAD",
    "descriptionCurrency": "dólar namibio",
    "symbol": "$"
  },
  {
    "currency": "NGN",
    "descriptionCurrency": "naira nigeriana",
    "symbol": "₦"
  },
  {
    "currency": "NIO",
    "descriptionCurrency": "córdoba nicaragüense",
    "symbol": "C$"
  },
  {
    "currency": "NOK",
    "descriptionCurrency": "corona noruega",
    "symbol": "kr"
  },
  {
    "currency": "NPR",
    "descriptionCurrency": "rupia nepalesa",
    "symbol": "₨"
  },
  {
    "currency": "NZD",
    "descriptionCurrency": "dólar neozelandés",
    "symbol": "$"
  },
  {
    "currency": "OMR",
    "descriptionCurrency": "rial omaní",
    "symbol": "﷼"
  },
  {
    "currency": "PAB",
    "descriptionCurrency": "balboa panameño",
    "symbol": "B/."
  },
  {
    "currency": "PEN",
    "descriptionCurrency": "sol peruano",
    "symbol": "S/."
  },
  {
    "currency": "PGK",
    "descriptionCurrency": "kina papuana",
    "symbol": "K"
  },
  {
    "currency": "PHP",
    "descriptionCurrency": "peso filipino",
    "symbol": "₱"
  },
  {
    "currency": "PKR",
    "descriptionCurrency": "rupia pakistaní",
    "symbol": "₨"
  },
  {
    "currency": "PLN",
    "descriptionCurrency": "zloty polaco",
    "symbol": "zł"
  },
  {
    "currency": "PYG",
    "descriptionCurrency": "guaraní paraguayo",
    "symbol": "₲"
  },
  {
    "currency": "QAR",
    "descriptionCurrency": "rial catarí",
    "symbol": "﷼"
  },
  {
    "currency": "RON",
    "descriptionCurrency": "leu rumano",
    "symbol": "L"
  },
  {
    "currency": "RSD",
    "descriptionCurrency": "dinar serbio",
    "symbol": "Дин."
  },
  {
    "currency": "RUB",
    "descriptionCurrency": "rublo ruso",
    "symbol": "₽"
  },
  {
    "currency": "RWF",
    "descriptionCurrency": "franco ruandés",
    "symbol": "FRw"
  },
  {
    "currency": "SAR",
    "descriptionCurrency": "rial saudí",
    "symbol": "﷼"
  },
  {
    "currency": "SBD",
    "descriptionCurrency": "dólar salomonense",
    "symbol": "$"
  },
  {
    "currency": "SCR",
    "descriptionCurrency": "rupia seychellense",
    "symbol": "₨"
  },
  {
    "currency": "SDG",
    "descriptionCurrency": "libra sudanesa",
    "symbol": "£"
  },
  {
    "currency": "SEK",
    "descriptionCurrency": "corona sueca",
    "symbol": "kr"
  },
  {
    "currency": "SGD",
    "descriptionCurrency": "dólar singapurense",
    "symbol": "$"
  },
  {
    "currency": "SHP",
    "descriptionCurrency": "libra de Santa Elena",
    "symbol": "£"
  },
  {
    "currency": "SLL",
    "descriptionCurrency": "leone de Sierra Leona",
    "symbol": "Le"
  },
  {
    "currency": "SOS",
    "descriptionCurrency": "chelín somalí",
    "symbol": "Sh"
  },
  {
    "currency": "SPL",
    "descriptionCurrency": "libra de San Bartolomé",
    "symbol": "£"
  },
  {
    "currency": "SRD",
    "descriptionCurrency": "dólar surinamés",
    "symbol": "$"
  },
  {
    "currency": "SSP",
    "descriptionCurrency": "libra sursudanesa",
    "symbol": "£"
  },
  {
    "currency": "STD",
    "descriptionCurrency": "dobra de Santo Tomé y Príncipe",
    "symbol": "Db"
  },
  {
    "currency": "STN",
    "descriptionCurrency": "dobra de Santo Tomé y Príncipe",
    "symbol": "Db"
  },
  {
    "currency": "SVC",
    "descriptionCurrency": "colón salvadoreño",
    "symbol": "$"
  },
  {
    "currency": "SYP",
    "descriptionCurrency": "libra siria",
    "symbol": "ل.س"
  },
  {
    "currency": "SZL",
    "descriptionCurrency": "lilangeni suazi",
    "symbol": "L"
  },
  {
    "currency": "THB",
    "descriptionCurrency": "baht tailandés",
    "symbol": "฿"
  },
  {
    "currency": "TJS",
    "descriptionCurrency": "somoni tayiko",
    "symbol": "SM"
  },
  {
    "currency": "TMT",
    "descriptionCurrency": "manat turcomano",
    "symbol": "m"
  },
  {
    "currency": "TND",
    "descriptionCurrency": "dinar tunecino",
    "symbol": "د.ت"
  },
  {
    "currency": "TOP",
    "descriptionCurrency": "paʻanga tongano",
    "symbol": "T$"
  },
  {
    "currency": "TRY",
    "descriptionCurrency": "lira turca",
    "symbol": "₺"
  },
  {
    "currency": "TTD",
    "descriptionCurrency": "dólar de Trinidad y Tobago",
    "symbol": "TT$"
  },
  {
    "currency": "TVD",
    "descriptionCurrency": "dólar tuvaluano",
    "symbol": "$"
  },
  {
    "currency": "TWD",
    "descriptionCurrency": "nuevo dólar taiwanés",
    "symbol": "NT$"
  },
  {
    "currency": "TZS",
    "descriptionCurrency": "chelín tanzano",
    "symbol": "Sh"
  },
  {
    "currency": "UAH",
    "descriptionCurrency": "grivna ucraniana",
    "symbol": "₴"
  },
  {
    "currency": "UGX",
    "descriptionCurrency": "chelín ugandés",
    "symbol": "USh"
  },
  {
    "currency": "USD",
    "descriptionCurrency": "dólar estadounidense",
    "symbol": "$"
  },
  {
    "currency": "UYU",
    "descriptionCurrency": "peso uruguayo",
    "symbol": "$U"
  },
  {
    "currency": "UZS",
    "descriptionCurrency": "sum uzbeko",
    "symbol": "сўм"
  },
  {
    "currency": "VEF",
    "descriptionCurrency": "bolívar venezolano",
    "symbol": "Bs F"
  },
  {
    "currency": "VES",
    "descriptionCurrency": "bolívar soberano",
    "symbol": "Bs."
  },
  {
    "currency": "VND",
    "descriptionCurrency": "dong vietnamita",
    "symbol": "₫"
  },
  {
    "currency": "VUV",
    "descriptionCurrency": "vatu vanuatuense",
    "symbol": "VT"
  },
  {
    "currency": "WST",
    "descriptionCurrency": "tala samoano",
    "symbol": "WS$"
  },
  {
    "currency": "XAF",
    "descriptionCurrency": "franco CFA centroafricano",
    "symbol": "FCFA"
  },
  {
    "currency": "XCD",
    "descriptionCurrency": "dólar del Caribe Oriental",
    "symbol": "$"
  },
  {
    "currency": "XDR",
    "descriptionCurrency": "derechos especiales de giro",
    "symbol": "XDR"
  },
  {
    "currency": "XOF",
    "descriptionCurrency": "franco CFA de África Occidental",
    "symbol": "CFA"
  },
  {
    "currency": "XPF",
    "descriptionCurrency": "franco CFP",
    "symbol": "CFPF"
  },
  {
    "currency": "YER",
    "descriptionCurrency": "rial yemení",
    "symbol": "﷼"
  },
  {
    "currency": "ZAR",
    "descriptionCurrency": "rand sudafricano",
    "symbol": "R"
  },
  {
    "currency": "ZMW",
    "descriptionCurrency": "kwacha zambiano",
    "symbol": "ZK"
  },
  {
    "currency": "ZWL",
    "descriptionCurrency": "dólar zimbabuense",
    "symbol": "Z$"
  }
]

export const worldCurrencies = currencies